import React from "react";
import PropTypes from "prop-types";
import { Card, Header, Icon } from "semantic-ui-react";

import _get from "lodash/get";

const filterDescriptionType = (descriptionType, descriptions) => {
  const filtered = descriptions.filter(
    (description) => description.descriptionType === descriptionType,
  );
  return filtered.length > 0
    ? filtered[0].descriptionText
    : "No description with the specified type found.";
};

const cleanDescription = (description) => {
  return description ? description.replace(/<\/?[^>]+(>|$)/g, "") : description;
};

function formatTemporalCoverage(data) {
  // Get earliest startDate and latest endDate
  const startDates = data.map((d) => new Date(d.startDate));
  const endDates = data.map((d) => new Date(d.endDate));

  const earliest = new Date(Math.min(...startDates));
  const latest = new Date(Math.max(...endDates));

  // Helper to format as "Month YYYY"
  const formatDate = (date) =>
    date.toLocaleString("en-US", { month: "long", year: "numeric" });

  return `${formatDate(earliest)}-${formatDate(latest)}`;
}

const HomepageRecordsListItem = ({ record }) => {
  const self_html = record?.links.self_html;
  const metadata = record?.metadata;
  const titles = _get(metadata, "titles", [{ titleText: "No Title" }]);
  const title = titles[0].titleText;
  const cleanedDescription = cleanDescription(
    filterDescriptionType("Abstract", metadata?.descriptions || []),
  );
  const publicationDate = metadata?.publicationDate
    ? metadata.publicationDate
    : "1/1/1970";
  const creator =
    metadata?.creators && metadata.creators.length > 0
      ? metadata?.creators[0]?.creatorGivenName +
        metadata.creators[0].creatorFamilyName
      : "--";
  const temporalCoverage = metadata?.temporalCoverages
    ? formatTemporalCoverage(metadata.temporalCoverages)
    : "--";
  return (
    <Card fluid href={self_html} className="homepage-listing-item">
      <Card.Content>
        <Header as="h4" style={{ marginBottom: "0.5rem" }}>
          <Icon name="file alternate outline" color="orange" />
          <Header.Content>{title || "No title"}</Header.Content>
        </Header>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            marginBottom: "0.5rem",
            color: "#555",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginRight: "1.5rem",
            }}
          >
            <Icon
              name="user outline"
              size="small"
              style={{ marginRight: "0.25rem" }}
              color="orange"
            />
            <span>{creator}</span>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginRight: "1.5rem",
            }}
          >
            <Icon
              name="calendar alternate outline"
              size="small"
              style={{ marginRight: "0.25rem" }}
              color="orange"
            />
            <span>{temporalCoverage}</span>
          </div>

          <div style={{ display: "flex", alignItems: "center" }}>
            <Icon
              name="upload"
              size="small"
              style={{ marginRight: "0.25rem" }}
              color="orange"
            />
            <span>Publicated: {publicationDate}</span>
          </div>
        </div>

        <Card.Description
          className="single-line-text"
          style={{ color: "#444" }}
        >
          {cleanedDescription || "No description"}
        </Card.Description>
      </Card.Content>
    </Card>
  );
};

HomepageRecordsListItem.propTypes = {
  record: PropTypes.object,
};

export default HomepageRecordsListItem;
